import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppProviders";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import USP from "@/components/landing/USP";
import ValueProps from "@/components/landing/ValueProps";
import Disciplines from "@/components/landing/Disciplines";
import AIAssistant from "@/components/landing/AIAssistant";
import ROICockpit from "@/components/landing/ROICockpit";
import Whitelabel from "@/components/landing/Whitelabel";
import Audience from "@/components/landing/Audience";
import Pricing from "@/components/landing/Pricing";
import LicenseMatrix from "@/components/landing/LicenseMatrix";
import KlantPortaal from "@/components/landing/KlantPortaal";
import Academy from "@/components/landing/Academy";
import Trial from "@/components/landing/Trial";
import Downloads from "@/components/landing/Downloads";
import Activation from "@/components/landing/Activation";
import FAQ from "@/components/landing/FAQ";
import Compliance from "@/components/landing/Compliance";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";
import Terms from "@/components/landing/Terms";
import Shop from "@/pages/Shop";
import Checkout from "@/pages/Checkout";
import ThankYou from "@/pages/ThankYou";
import ActivateHelp from "@/pages/ActivateHelp";

const Landing = () => (
  <div className="min-h-screen bg-background text-foreground font-body antialiased selection:bg-blue-600/30">
    <Header />
    <main>
      <Hero />
      <USP />
      <ValueProps />
      <Disciplines />
      <AIAssistant />
      <ROICockpit />
      <Whitelabel />
      <Audience />
      <Pricing />
      <LicenseMatrix />
      <KlantPortaal />
      <Academy />
      <Trial />
      <Downloads />
      <Activation />
      <FAQ />
      <Compliance />
      <ContactForm />
    </main>
    <Footer />
  </div>
);

const AppShell = () => {
  const { theme } = useApp();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/activate-help" element={<ActivateHelp />} />
      </Routes>
      <Terms />
      <Toaster theme={theme} position="bottom-right" richColors />
    </BrowserRouter>
  );
};

function App() {
  return (
    <AppProvider>
      <AppShell />
    </AppProvider>
  );
}

export default App;
